import React from "react";
import { FiArrowLeft, FiSave } from "react-icons/fi";

const ChildAddSection = ({
  t,
  newChild = {},
  handleNewChildChange,
  handleCreateChild,
  onCancel,
  submitting = false,
}) => {
  const canSubmit = !submitting && Boolean(newChild.firstName && newChild.lastName && newChild.dateBirth && newChild.gender);

  const submit = (event) => {
    event.preventDefault();
    if (!canSubmit) return;
    handleCreateChild?.(event);
  };

  return (
    <form onSubmit={submit} className="px-6 py-5">
      <div className="mb-5 flex items-center justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-emerald-700 dark:text-emerald-300">
            {t("parentPortal.children.new_child", { defaultValue: "New child" })}
          </p>
          <h3 className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
            {t("parentPortal.create_child_title", { defaultValue: "Register new child" })}
          </h3>
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-3 py-2 text-sm font-bold text-slate-600 transition hover:border-emerald-300 hover:bg-emerald-50 hover:text-emerald-800 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-emerald-950/30"
        >
          <FiArrowLeft className="h-4 w-4" aria-hidden="true" />
          {t("common.back", { defaultValue: "Back" })}
        </button>
      </div>

      <div className="grid gap-4">
        <label className="block">
          <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
            {t("parentPortal.first_name", { defaultValue: "First name" })}
          </span>
          <input
            type="text"
            name="firstName"
            value={newChild.firstName || ""}
            onChange={handleNewChildChange}
            className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-950 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-slate-700 dark:bg-slate-950/30 dark:text-white dark:focus:ring-emerald-950/40"
            placeholder={t("parentPortal.first_name", { defaultValue: "First name" })}
          />
        </label>

        <label className="block">
          <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
            {t("parentPortal.last_name", { defaultValue: "Last name" })}
          </span>
          <input
            type="text"
            name="lastName"
            value={newChild.lastName || ""}
            onChange={handleNewChildChange}
            className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-950 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-slate-700 dark:bg-slate-950/30 dark:text-white dark:focus:ring-emerald-950/40"
            placeholder={t("parentPortal.last_name", { defaultValue: "Last name" })}
          />
        </label>

        <div className="grid gap-4 sm:grid-cols-2">
          <label className="block">
            <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
              {t("parentPortal.date_birth", { defaultValue: "Date of birth" })}
            </span>
            <input
              type="date"
              name="dateBirth"
              value={newChild.dateBirth || ""}
              onChange={handleNewChildChange}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-950 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-slate-700 dark:bg-slate-950/30 dark:text-white dark:focus:ring-emerald-950/40"
            />
          </label>

          <label className="block">
            <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
              {t("parentPortal.gender", { defaultValue: "Gender" })}
            </span>
            <select
              name="gender"
              value={newChild.gender || ""}
              onChange={handleNewChildChange}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-950 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-slate-700 dark:bg-slate-950/30 dark:text-white dark:focus:ring-emerald-950/40"
            >
              <option value="">{t("children.common.select_gender", { defaultValue: "Select gender" })}</option>
              <option value="MALE">{t("children.common.gender_male", { defaultValue: "Male" })}</option>
              <option value="FEMALE">{t("children.common.gender_female", { defaultValue: "Female" })}</option>
            </select>
          </label>
        </div>
      </div>

      <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onCancel}
          className="inline-flex items-center justify-center rounded-full border border-slate-200 px-5 py-3 text-sm font-bold text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-900"
        >
          {t("common.cancel", { defaultValue: "Cancel" })}
        </button>
        <button
          type="submit"
          disabled={!canSubmit}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-600 px-5 py-3 text-sm font-bold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <FiSave className="h-4 w-4" aria-hidden="true" />
          {submitting
            ? t("common.saving", { defaultValue: "Saving..." })
            : t("parentPortal.create_child", { defaultValue: "Register child" })}
        </button>
      </div>
    </form>
  );
};

export default ChildAddSection;
